import FixIt from '../modules/module.fixit';
import { breakpoints ,toggleOverlay,getSelectedfilterlabels,setdefaultFilteractive,getSelectedFilterCount, checkTypeRefinement} from '../helpers/born.utils';
import { selectItem } from '../helpers/gtm.utils';
import lazyPictureLoad from '../lazypictureload';
import {categoryOfferTimer} from '../offertimer';
import { selectBannerPromotion } from '../helpers/gtm.utils';
import { selectPromotion } from '../helpers/gtm.utils';
import { initCategoryNavigation } from '../helpers/gtm.utils';


var util = require('../util'),
    progress = require('../progress');
var haveSelectedFilter = false;
var retainfilterSelected = null;
window.selectedStickyFilter = null;
var lastAppliedOrRemovedFilterOffset = 0;
var lastInnerScrollPosition = 0;
var lastScrollPosition = 0;
var userPastOverlayScrollPos = [0,0];

// selected filter view more functionality
function filterOverflowToggle() {
    var $badgeContainer = $('#badgeContainer');
    var $overflowTrigger = $('#badgeOverflowTrigger');
    var $badgeOverflowLimit = $('#badgeOverflowLimit');
    var overflowClass = "allow-overflow";
    if ($badgeOverflowLimit.height() > 82) {
        $overflowTrigger.removeClass('visually-hidden');
    } else {
        $overflowTrigger.addClass('visually-hidden');
    }
    showHiddenFilterCount(); // get count of hidden items
    $overflowTrigger.on('click', () => {
        if ($badgeContainer.hasClass(overflowClass)) {
            $badgeContainer.removeClass(overflowClass);
            $overflowTrigger.removeClass(overflowClass);
        } else {
            $badgeContainer.addClass(overflowClass);
            $overflowTrigger.addClass(overflowClass);
        }
    });
}

//set parent width as same as child to avoid jerk on sticky filters (web only)
function setStickyFilterWidth() {
    const makeSticky = (e) => {
        if ($(window).width() > 767) {
            $('.refinement__static-filter').each(function () {
                var $child = $(this).find('form.web-sort-by-toggle, form.web-sort-by-filter');
                var width = $child.width();
                $(this).width(width);
            });
        } else {
            $('.refinement__static-filter').each(function () {
                $(this).removeAttr('style');
            });
        }
    }
    makeSticky();
    $(window).on('resize', makeSticky);
}

//dock the web filter list to top if scrolled past (web only)
function dockFilters() {
    const havePLPTimer = $('.plp__offer__timer').length > 0;
    havePLPTimer && $('#refinementOptions').addClass('has-plp-timer');
    const dockEnableCheck = (offset, toggleItem, toggleClass) => {
        var currentScroll = $(window).scrollTop();
        if (currentScroll >= offset && currentScroll < ($(document).height() - window.innerHeight - 150)) {
            toggleItem.addClass(toggleClass);
        } else {
            toggleItem.removeClass(toggleClass);
        }
    };
    const doDocking = () => {
        var $refinementItem = $('#refinementOptions');
        var $productGrid = $('#productGridContainer');

        if ($(window).width() > 767) {
            $(window).off('scroll.mobileScrollEvent');
            $productGrid.removeClass('dock-to-relative');

            var fixmeTop = $refinementItem.offset().top;

            dockEnableCheck(fixmeTop - 117,$refinementItem,'docked-at-top'); //do the check on load also

            $(window).on('scroll.webScrollEvent', function () {
                dockEnableCheck(fixmeTop - 117,$refinementItem,'docked-at-top');
            });
        } else {
            $(window).off('scroll.webScrollEvent');
        }
    }
    doDocking();
    $(window).on('resize', doDocking);
}

// cut paste the seo div while switching to mobile view or back
function cutPasteSEO() {
    var $seoMob = $('#seo-mob');
    var $seoDesk = $('#seo-desktop');
    const doCutPaste = () => {
        var $seoContent = $('#refine-catseotexthead');
        if ($(window).width() > 767) {
            if ($seoContent.parent() !== $seoDesk) {
                $seoContent.remove();
                $seoDesk.append($seoContent);
                $seoContent.addClass('display--small-up').find('.cat-seo-text').addClass('toggle--active');
            }
        } else {
            if ($seoContent.parent() !== $seoMob) {
                $seoContent.remove();
                $seoMob.append($seoContent);
                $seoContent.removeClass('display--small-up').find('.cat-seo-text').addClass('toggle--active');
            }
        }
    };
    doCutPaste();
    $(window).on('resize', doCutPaste);
}

// show the count of filters hidden by the overflow
function showHiddenFilterCount() {
    var $containerParent = $('#badgeOverflowLimit');
    var $badges = $containerParent.find('.filter-badge');
    var offsets = [];

    const calcCount = () => {
        $badges.each(function () {
            offsets.push($(this).offset().top);
        });
        offsets = Array.from(new Set(offsets));
        var count = offsets.length > 1 ? $badges.filter(function () {
            return $(this).offset().top > offsets[1];
        }).length : 0;
        $('#badgeOverflowTrigger').find('.content-to-replace').html(count);
    }
    calcCount();
}

//cancel scroll if sort is open (mobile only)
// sort click away listener
function sortScrollAndClickAway() {
    var $toggledElements = $('.web-sort-by-toggle,.web-sort-by-filter,.refinement__static-filter');
    const propagationHandler=(e)=> {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        if ($toggledElements.hasClass('toggle--active')) {
            $toggledElements.removeClass('toggle--active');
            //avoid sort menu closing, if clicked inside the menu
            $('#main').off('click','.web-sort-by-toggle,.web-sort-by-filter',(e) => e.stopPropagation());
            $(window).off('click', propagationHandler);
            $('body').removeClass('cancel-scroll');
        }
        if ($(window).width() <= 767 && $(e.currentTarget).is('.refinement__sorts')) {
            if(typeof zE !== 'undefined' && !!zE) {
                zE(function() {
                   zE.show();
                });
            }
        }
        saveStickyToggleState();
    }
    $('.refinement__static-filter').on('click', function (e) {
        var width = $(window).width();
        var isLink = $(e.target).is('.refinement--link, .refinement-text, .refinement_filtercount');
        if ($(e.currentTarget).hasClass('toggle--active')) {
            if (width <= 767) {
                $('body').removeClass('cancel-scroll');
                if ($(e.currentTarget).is('.refinement__sorts') && !isLink) {
                    if(typeof zE !== 'undefined' && !!zE) {
                        zE(function() {
                           zE.show();
                        });
                    }
                }
            }
            if (!isLink) {
                $(e.currentTarget).removeClass('toggle--active').find('.toggle__link, .toggle__content, .web-sort-by-filter, .web-sort-by-toggle').removeClass('toggle--active'); 
            }
            //avoid sort menu closing, if clicked inside the menu
            $('#main').off('click','.web-sort-by-toggle,.web-sort-by-filter',(e) => e.stopPropagation());
            $(window).off('click', propagationHandler);
        } else {
            if (width <= 767) {
                $('body').addClass('cancel-scroll');
                if ($(e.currentTarget).is('.refinement__sorts')) {
                    if(typeof zE !== 'undefined' && !!zE) {
                        zE(function() {
                           zE.hide();
                        });
                    }
                }
            }
            $toggledElements.removeClass('toggle--active');
            $(e.currentTarget).addClass('toggle--active').find('.toggle__link, .toggle__content, .web-sort-by-filter, .web-sort-by-toggle').addClass('toggle--active');            //avoid sort menu closing, if clicked inside the menu
            $('#main').on('click','.web-sort-by-toggle,.web-sort-by-filter',(e) => e.stopPropagation());
            $(window).on('click', propagationHandler);
        }
        if (!$(e.target).is('.refinement--link, .refinement-text, .refinement_filtercount')) {
            saveStickyToggleState();
        }
    });
    $('.filterby-toggle-head').on('click', function (e) {
            $('body').addClass('cancel-scroll');
            ($(window).width() <= 767) ? scrollLockIos(true) : "";
            window.filteroverlay = true;
    });
    $('.filterapply,.filterapply--mob,.filter--mob-backbtn,.refinement__filter_close').on('click', function (e) {
            $('body').removeClass('cancel-scroll');
            ($(window).width() <= 767) ? scrollLockIos(false) : "";
    });
}
//Overlay Scroll Fix in IOS
function scrollLockIos(state){
    if(state === true){
        userPastOverlayScrollPos = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
        ];
        $('html').addClass('cancel-scroll noscrollios');
    }else{
        $('html').removeClass('cancel-scroll noscrollios');
        window.scrollTo(userPastOverlayScrollPos[0], userPastOverlayScrollPos[1]);
    }
}

function setHaveSelectedFilter() {
    $('.refinement.toggle--nb').on('click.setHaveSelectedFilter', function (e) {
        var width = $(window).width();
        if (width > 767) {
            return;
        }
        var $eleList = $('.refinement.toggle--nb');
        var idx = $eleList.index(this);
        if (idx != 0) {
            if ($('.refinement.toggle--nb.activefilter').first() !== $eleList.first()) {
                haveSelectedFilter = true;
            } else {
                haveSelectedFilter = false;
           }
        }
    });
}

export function saveStickyToggleState() {
    var $activefilter = $('.refinement__static-filter.toggle--active:not(.refinement__sorts)');    
    if($activefilter.length > 0){
        $activefilter.each((ind,ele)=>{
            window.selectedStickyFilter = ($(ele).attr('id') !== window.selectedStickyFilter) ? $(ele).attr('id') : window.selectedStickyFilter;
        });
    }else{
        window.selectedStickyFilter = null;
    }
}

function instantHighlighter() {
    $('.refinement__all__toggle').first().find('.refinement__link.control-label.checkbox').on('click', function (e) {
        $(e.currentTarget).toggleClass('checked');
        lastAppliedOrRemovedFilterOffset = $('.refinement__all__toggle').scrollTop();
        lastInnerScrollPosition =  $(e.currentTarget).parents('.toggle__content').first().scrollTop();
    });
    $('.refinement__clear.refinement__web_clearfilter').first().on('click', e => {
        $('.refinement__all__toggle').first().find('.refinement__link.control-label.checkbox').removeClass('checked');
        $('.refinement__categorybrandrefinement .refinement__all__toggle').find('.active').removeClass('active');
        lastAppliedOrRemovedFilterOffset = 0;
        userPastOverlayScrollPos = [0,0];
        $('.expandable').removeClass('active').find('.active').removeClass('active');
    });
    //PLP filter highlighter
    $('.refinement__web_cmfilter .refinement--link').on('click', function (e) {
        $(this).toggleClass('checked');
        lastScrollPosition =  $(e.currentTarget).parents('.toggle__content').first().scrollTop();
    });
}

function productTypeSelectPostOp() {
    $('#categoryBrandRefinementMob .typerefinements .refinement__link').on('click', () => {
        $(document).one('ajaxStop', function () {
            setTimeout(() => {
                $('#categoryBrandRefinementMob').addClass('activefilter').find('.toggle__link, .toggle__content').addClass('toggle--active');
            }, 0);
        });
    });
    $('#categoryRefinement .typerefinements .refinement__link').on('click', () => {
        $(document).one('ajaxStop', function () {
            setTimeout(() => {
                $('#categoryRefinement').addClass('activefilter').find('.toggle__link, .toggle__content').addClass('toggle--active');
            }, 0);
        });
    });
}

export function PLPCategoryToggle() {
    $('.category-list.has-children a.category-click').on('click', function (e) {
        if ($(this).closest('.category-list').hasClass('last-child')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('active').closest('.expandable').toggleClass('active');
    });
}

export function setFilterScrollPosition() {
    lastAppliedOrRemovedFilterOffset > 0 && $('.refinement__all__toggle').animate({
        scrollTop: lastAppliedOrRemovedFilterOffset
    }, 500);
}
export function setOverlayInnerScroll(scrollItem,origin) {
    if(origin == "overlay"){
        lastInnerScrollPosition > 0 && $(`#${scrollItem}`).parents('.toggle__content').animate({
            scrollTop: lastInnerScrollPosition
        }, 500);
    }else{
         lastScrollPosition > 0 && $(`#${scrollItem}`).find('.toggle__content').animate({
            scrollTop: lastScrollPosition
        }, 500);
    }
}

function initBreadCrumbOverFlow() {
    let $breadcrumbs = $('#breadcrumbs'),
        isBreadCrumbOverflown = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0));
    if (isBreadCrumbOverflown) {
        $breadcrumbs.addClass('show-ellipsis');
    } else {
        $breadcrumbs.removeClass('show-ellipsis');
    }
}

function isOverflown(element) {
    return element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
}

//function to check browser agent to apply specific styles for mac-safari in plp-promo-tile slot.
function checkIfBrowserMacSafari(){
    if(typeof navigator !== 'undefined' && typeof navigator.platform !== 'undefined' && typeof navigator.userAgent !== 'undefined'&& navigator.platform.toUpperCase().indexOf('MAC')>=0 && (/^((?!chrome|android).)*safari/i.test(navigator.userAgent))){
        $(".plp-listing-promo").removeClass("zero-padding");
    }
}


export function init() {
    const $filterElements = $(".refinements__filtercontainer .refinement");
    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
        const lazyLoadConfig = { observerId: 'search-result-items', preloadExpandBy: 100 };
        lazyPictureLoad.init(lazyLoadConfig);
    }
	$(document).ready(function () {
		//Filter list narrowing
		$(document).on("keyup",".refinement__filtersearch",function(e){
			let value = $.trim($(this).val().toLowerCase());
			let childele = ($(window).width() <= 767) ? $(this).parent().siblings('.toggle__content').find('li:not(.refinement_nofiltervalue)') : $(this).siblings('.toggle__content').find('li:not(.refinement_nofiltervalue)');
			childele.hide().filter(function() {
				return $(this).find('a').immediateText().toLowerCase().indexOf(value) > -1;
			}).show();
			if($(window).width() <= 767)
				($(this).parent().siblings('.toggle__content').find('li:not(.refinement_nofiltervalue):visible').length == 0) ? $(this).parent().siblings('.toggle__content').find('.refinement_nofiltervalue').show() : $(this).parent().siblings('.toggle__content').find('.refinement_nofiltervalue').hide();
			else
				($(this).siblings('.toggle__content').find('li:not(.refinement_nofiltervalue):visible').length == 0) ? $(this).siblings('.toggle__content').find('.refinement_nofiltervalue').show() : $(this).siblings('.toggle__content').find('.refinement_nofiltervalue').hide();
		});

        $(window).on('popstate', function(event) {
            if($(".refinements__filtercontainer").hasClass('toggle--active')){
                $(".refinements__filtercontainer").removeClass('toggle--active');
                $(".refinement-wrapper").removeClass('toggle--active')
                toggleOverlay();
            }
        });

		//FilterPanel View
		$(document).on("click",".refinement__filterby--head",function(e){
			if(typeof zE !== 'undefined' && !!zE) {
                zE(function() {
                   zE.hide();
                });
            }
			toggleFilterPanel('show');
		});
		//FilterPanel Close
		$(document).on("click",".refinement__filter_close,.filterapply,.filter--mob-backbtn,.filterapply--mob",function(){
			if(typeof zE !== 'undefined' && !!zE) {
                zE(function() {
                   zE.show();
                });
            }
            window.filteroverlay = false;
			toggleFilterPanel('hide');
		});

		//Clearing individual narrowing on clear all scenario
		$(document).on("click",".refinement__web_clearfilter,.clear-filter-btn",function(e){
			$(".refinement__filtersearch").val("");
			$(".refinement__filtersearch").siblings('.toggle__content').find('li:not(.refinement_nofiltervalue)').show();
			let $firstEleView = $(".refinements__filtercontainer .refinement:first");
			if($(this).hasClass('refinement__web_clearfilter') && !($(this).hasClass('refinement__disable'))){
               progress.show($(".refinements__filtercontainer"));
				if($(window).width() <= 767){
					$firstEleView = ($firstEleView.children().length > 0) ? $firstEleView : $firstEleView.next();
					setdefaultFilteractive($filterElements,$firstEleView);
				}else{
					$filterElements.removeClass('toggle--active');
					$filterElements.find('.toggle__link').removeClass('toggle--active');
					$filterElements.find('.toggle__content').removeClass('toggle--active');
				}
			}
            retainfilterSelected = $firstEleView.attr('id');
            $('.expandable').removeClass('active').find('.active').removeClass('active');
		});

		$(document).on('click',".refinement__selected-filters .filter-badge button",function(){
			if($(".filter-badge").length  == 0)
                 retainfilterSelected = null;
		});
		//Mobile filter view handling
		$(document).on("click",".refinements__filtercontainer .refinement", function(e){
			if($(window).width() <= 767)
				setdefaultFilteractive($filterElements,$(this));
		});

		$(document).on("click",".refinements__filtercontainer .refinement__link,.refinement__all__toggle .refinement__clear",function(e){
			let target = $(this).parents('.refinement').attr('id');
            userPastOverlayScrollPos = [0,0];
            progress.show($(".refinements__filtercontainer"));
            retainfilterSelected = target;
		});
        selectItem();
        selectPromotion();
        selectBannerPromotion();
        initCategoryNavigation();
        checkIfBrowserMacSafari();
	});

	$(window).on('resize',function(){
		clearTimeout(window.resizeFinished);
		window.resizeFinished = setTimeout(function(){
				if ($('.refinements__filtercontainer').hasClass('toggle--active')) {
					$(".refinement-wrapper").addClass('toggle--active');
					if($(window).width() <= 767){
						handleMobilelayout();
						getSelectedFilterCount();
					}else{
						let checkSelectedItem  = $(".refinement__link.checked");
						if(checkSelectedItem.length == 0){
							$filterElements.children('.toggle__content,.toggle__link').removeClass('toggle--active');
						}
						getSelectedfilterlabels();
						toggleOverlay(true,true);
						$(".focus-overlay").addClass('forcily-visible');
					}
                    setFilterScrollPosition();
				}else{
					if($('.refinements__filtercontainer.toggle--active, .header__secondary.toggle--active').length === 0) {
                        toggleOverlay();
                    }
					($(window).width() <= 767) ? $(".refinement-wrapper").removeClass('toggle--active') : $(".refinements__filtercontainer").removeClass('toggle--active')
				}
		}, 800);

		initBreadCrumbOverFlow();
    });

	function toggleFilterPanel(trigger){
		if(trigger == 'show'){
			$(".refinements__filtercontainer,.refinement-wrapper").addClass('toggle--active');
			if($(window).width() <= 767){
				handleMobilelayout();
				getSelectedFilterCount();
			}else{
				getSelectedfilterlabels();
				toggleOverlay(true,true);
			}
			checkTypeRefinement();
		}else{
			$(".refinements__filtercontainer,.refinement-wrapper").removeClass('toggle--active');
			toggleOverlay(false,false);
			$(".focus-overlay").removeClass('forcily-visible');
		}

    }

    filterOverflowToggle();
    setStickyFilterWidth();
    dockFilters();
    cutPasteSEO();
    sortScrollAndClickAway();
    setHaveSelectedFilter();
    instantHighlighter();
    PLPCategoryToggle();
    productTypeSelectPostOp();
    categoryOfferTimer();
    initBreadCrumbOverFlow();
	$.fn.immediateText = function() {
		return this.contents().not(this.children()).text();
	};

	const handleMobilelayout = () => {
		toggleOverlay(false,false,false);
		let $firstEleView = "";
		$(".focus-overlay").removeClass('forcily-visible');
		$firstEleView = (retainfilterSelected !== null) ? $(`#${retainfilterSelected}`) :  $(".refinements__filtercontainer .refinement:first");
		$firstEleView = ($firstEleView.children().length > 0) ? $firstEleView : $firstEleView.next();
        !haveSelectedFilter && setdefaultFilteractive($filterElements,$firstEleView);
    }
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/plp.js